import React from 'react'
import { AppBar, Typography } from '@material-ui/core'

import FichaContribuicaoIndevida from './FichaContribuicaoIndevida'
import FichaContribuicoesDescontadas from './FichaContribuicoesDescontadas'
import FichaDadosIniciais from './FichaDadosIniciais'
import FichaGPS from './FichaGPS'
import FichaNovoDocumento from './FichaNovoDocumento'

import { useStyles as useDrawerStyles } from '../styles'
import { formataCpf, formatarReais } from '../../../../../Utils/utils'

export default function DadosEspelho({ dadosEspelho, modoImprimir = false, modoImprimirTodos = false, nome='', cpf='', resultadoSelecionado={} }) {

    const classes = useDrawerStyles();

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            {modoImprimir && <div style={{ padding: 20, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ marginLeft: 10 }}>
                    <Typography style={{ fontWeight: 700, fontSize: 14 }}>{nome}</Typography>
                </div>
                <div style={{ marginLeft: 12 }}>
                    <Typography style={{ fontWeight: 400, fontSize: 14 }}>{formataCpf(cpf)}</Typography>
                </div>
                <div style={{ marginLeft: 12 }}>
                    <Typography style={{ fontWeight: 400, fontSize: 14 }}>{'Competência: ' + (resultadoSelecionado.competencia ?? "xx/xxxx")}</Typography>
                </div>
                <div style={{ flexGrow: 1 }} />
            </div>}
            <div className={classes.rootAppBar}>
                <AppBar position="static" className={classes.appBar}>
                    <div className={classes.bodyAppBar}>
                        <Typography style={{ userSelect: 'none', fontWeight: 500 }}>RESTITUIÇÃO - ESPELHO PER/DCOMP</Typography>
                    </div>
                </AppBar>
            </div>
            <div style={{ paddingTop: 20, paddingLeft: 20, paddingRight: 20, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ marginLeft: 8 }}>
                    <Typography style={{ fontWeight: 400, fontSize: 14 }}><b>Crédito apurado na competência:</b>{` ${dadosEspelho.dadosRestituicao ? formatarReais(dadosEspelho.dadosRestituicao.valorCredito) : '-'}`}</Typography>
                </div>
            </div>
            <FichaNovoDocumento dadosEspelho={dadosEspelho} />
            <FichaDadosIniciais dadosEspelho={dadosEspelho} />
            <div style={{ display: 'flex', paddingLeft: 20, paddingRight: 20, marginBottom: 12 }}>
                <Typography style={{ fontSize: 14, textAlign: 'justify' }}>{`O Crédito, perfeitamente identificado no presente documento eletrônico, TEM, como fundamento a alegação de inconstitucionalidade de lei que: 1) não tem sido declarada inconstitucional pelo Supremo Tribunal Federal em ação direta de inconstitucionalidade ou em ação declaratória de inconstitucionalidade; 2) não tenha ido sua execução suspensa pelo Senado Federal; 3) não tenha sido julgada inconstitucional em sentença judicial transitada em julgado a favor do contribuinte; 4) não tenha sido o objecto de súmula vinculante aprovada pelo Supremo Tribunal Federal nos termos do artigo 103-A da Constituição Federal?`} <span className={modoImprimirTodos ? classes.spanImprimir : classes.span}>Não</span></Typography>
            </div>
            <FichaContribuicaoIndevida modoImprimirTodos={modoImprimirTodos} dadosEspelho={dadosEspelho} modoImprimir={modoImprimir} />
            <FichaGPS dadosEspelho={dadosEspelho} />
            <FichaContribuicoesDescontadas dadosEspelho={dadosEspelho} />
        </div>
    )
}